import { Link, useNavigate } from "react-router-dom";
import { SunIcon, MoonIcon } from "@heroicons/react/24/outline";
import { useAuth } from "@/App";
import { useTheme } from "@/context/ThemeContext";
import { BurgerMenu } from "./BurgerMenu";

const NAV_LINKS = [
  { label: "Dashboard", to: "/dashboard" },
  { label: "Add Job", to: "/jobs/new" },
  { label: "Profile", to: "/profile" },
  { label: "Help", to: "/help" },
];

export function NavBar() {
  const { signOut } = useAuth();
  const { theme, toggleTheme } = useTheme();
  const navigate = useNavigate();

  async function handleLogout() {
    await signOut();
    navigate("/login", { replace: true });
  }

  return (
    <nav className="sticky top-0 z-40 flex items-center gap-6 px-6 py-3 border-b border-slate-200 dark:border-slate-800 bg-white dark:bg-slate-900">
      {/* Logo */}
      <Link
        to="/dashboard"
        className="flex items-center gap-2 font-bold text-lg text-slate-900 dark:text-slate-100 no-underline"
      >
        <img src="/android-chrome-192x192.png" alt="" aria-hidden="true" className="h-[44px] w-[44px]" />
        Jobs Bot
      </Link>

      {/* Desktop inline links — hidden below md breakpoint */}
      <div className="hidden md:flex items-center gap-6 flex-1">
        {NAV_LINKS.map((link) => (
          <Link
            key={link.to}
            to={link.to}
            className="text-sm text-slate-600 dark:text-slate-400 no-underline hover:text-slate-900 dark:hover:text-slate-100 transition-colors duration-200"
          >
            {link.label}
          </Link>
        ))}
        <button
          onClick={toggleTheme}
          aria-label={theme === "dark" ? "Switch to light mode" : "Switch to dark mode"}
          className="ml-auto p-1.5 rounded text-slate-600 dark:text-slate-400 hover:bg-slate-100 dark:hover:bg-slate-800 transition-all duration-200 min-h-[44px] min-w-[44px] flex items-center justify-center"
        >
          {theme === "dark" ? (
            <SunIcon className="h-5 w-5" aria-hidden="true" />
          ) : (
            <MoonIcon className="h-5 w-5" aria-hidden="true" />
          )}
        </button>
        <button
          onClick={handleLogout}
          className="px-4 py-1.5 text-sm text-slate-600 dark:text-slate-400 border border-slate-300 dark:border-slate-600 rounded hover:bg-slate-100 dark:hover:bg-slate-800 transition-all duration-200 cursor-pointer bg-transparent"
        >
          Log out
        </button>
      </div>

      {/* Mobile burger — hidden at md and above */}
      <div className="md:hidden ml-auto">
        <BurgerMenu links={NAV_LINKS} />
      </div>
    </nav>
  );
}
